export const user = {
  titleModal: {
    create: '新規ユーザー作成',
    update: 'ユーザー編集',
  },
  loginId: 'ログインID',
  name: '名前',
  create: 'ユーザー作成',
  password: 'パスワード',
  confirmPassword: 'パスワード（確認）',
  company: '事業者',
  store: '店舗',
  store_in_charge: '担当店舗',
  rassword_reissue: 'パスワードの再発行 ',
  currentPassword: '現在パスワード',
};
